import React from 'react';
export const DaEditorContext = React.createContext(false);
DaEditorContext.displayName = 'DaEditorContext';

//# sourceMappingURL=DaEditorContext.js.map